import React from 'react';
import LessonNeck from './LessonNeck';
import { usePlayChord } from '../hooks/usePlayChord';

/**
 * Adaptateur entre le magasin de l'accord et le manche de Play : le seul
 * composant qui se rend a chaque accord de ce cote. Toutes les autres props
 * viennent de App inchangees, et GuitarNeckVisualizer reste memoise sur elles. Il enveloppe LessonNeck,
 * l'adaptateur frere du magasin de la lecon, qui rend le manche.
 *
 * fallbackChordNote est le point d'appui quand rien ne joue : la tonique
 * harmonique, pas la racine de la gamme d'impro affichee sur le manche.
 */
const PlayNeck = ({ fallbackChordNote = null, ...neckProps }) => {
  const { playingNote, activeChordNote, displayedChordNote } = usePlayChord();
  return (
    <LessonNeck
      {...neckProps}
      activeChordNote={displayedChordNote || activeChordNote || fallbackChordNote}
      playingNote={playingNote}
    />
  );
};

export default PlayNeck;
